var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNeededFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 18.25H6C4.76 18.25 3.75 17.24 3.75 16V8C3.75 7.59 3.41 7.25 3 7.25C2.59 7.25 2.25 7.59 2.25 8V16C2.25 18.07 3.93 19.75 6 19.75H14C14.41 19.75 14.75 19.41 14.75 19C14.75 18.59 14.41 18.25 14 18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5295 18.47L17.7495 16.69V5.83C17.7495 5.1 17.4595 4.4 16.9395 3.89L14.1095 1.06C13.5895 0.54 12.8995 0.25 12.1695 0.25H5.99945C4.75945 0.25 3.60945 0.88 2.91945 1.86L1.52945 0.47C1.23945 0.18 0.759453 0.18 0.469453 0.47C0.179453 0.76 0.179453 1.24 0.469453 1.53L2.63945 3.7L18.4595 19.53C18.6095 19.68 18.7995 19.75 18.9895 19.75C19.1795 19.75 19.3695 19.68 19.5195 19.53C19.8095 19.24 19.8095 18.76 19.5195 18.47H19.5295ZM5.99945 1.75H12.1695C12.4995 1.75 12.8195 1.88 13.0495 2.12L15.8795 4.95C16.1195 5.19 16.2495 5.5 16.2495 5.83V15.19L4.00945 2.95C4.38945 2.23 5.15945 1.75 5.99945 1.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNeededFile);
export default __webpack_public_path__ + "static/media/no-needed-file.a89d4e3f63bffcf1bfec7a7ec1192321.svg";
export { ForwardRef as ReactComponent };